export default __webpack_public_path__ + "static/media/322030_2_0.527562a7.woff";